// extracted by mini-css-extract-plugin
export var activeFilterButton = "_qq-c";
export var backButton = "_qq-4";
export var backIcon = "_qq-5";
export var chevronShortcut = "_qq-6";
export var container = "_qq-1";
export var editor = "_qq-8";
export var editorWrapper = "_qq-7";
export var prefix = "_qq-2";
export var searchIcon = "_qq-3";
export var suffix = "_qq-9";
export var suffixContent = "_qq-a";
export var suffixText = "_qq-b";
export var wrapper = "_qq-0";